// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable, fromEvent } from 'rxjs';

// --- 3rd Part
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { ApplicationError, ToastModel } from '../../models';
import { AppToastService } from './app-toast.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private _refCount: number;

  private _lastError$: BehaviorSubject<ApplicationError>;
  get lastError$(): Observable<ApplicationError> {
    return this._lastError$;
  }

  private _isOffLine$: BehaviorSubject<boolean>;
  get isOffLine$(): Observable<boolean>{
    return this._isOffLine$;
  }

  private _isLoading$: BehaviorSubject<boolean>;
  get isLoading$(): Observable<boolean> {
    return this._isLoading$;
  }

  private _showReportModal$: BehaviorSubject<boolean>;
  get showReportModal$(): Observable<boolean> {
    return this._showReportModal$;
  }

  constructor(private translate: TranslateService, private toastService: AppToastService) {
    this._refCount = 0;
    this._lastError$ = new BehaviorSubject<ApplicationError>(null);
    this._isLoading$ = new BehaviorSubject<boolean>(false);
    this._showReportModal$ = new BehaviorSubject<boolean>(false);
    this._isOffLine$ = new BehaviorSubject<boolean>(false);

    fromEvent<Event>(window, 'offline').subscribe(() => {
      this._isOffLine$.next(true);
    });  

    fromEvent<Event>(window, 'online').subscribe(() => {
      this._isOffLine$.next(false);
    });  
  }

  setLastError(error: ApplicationError): void {
    this.toastService.show({
      header: this.translate.instant('errorHeader'),
      body: error.errorMessage,
      class: 'bg-danger text-light',
      autoHide: false,
      delay: 0,
      link: '/error',
      error
    } as ToastModel);
    this._lastError$.next(error);
  }

  setLoading(isLoading: boolean): void {
    if (isLoading) {
      this._refCount++;
    } else {
      this._refCount--;
    }
    this._isLoading$.next(this._refCount > 0);
  }

  setShowReportModal(showModal: boolean) {
    this._showReportModal$.next(showModal);
  }
}
